import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import formReducer from './features/form';
import tlsSupportReducer from './tlsSupport';
import ibanReducer from './features/iban';
import priceReducer from './features/price';
import transactionReducer from './features/transaction';
import dealerReducer from './features/dealer';
import asosReducer from './features/asos';
import sessionReducer from './features/session';
import dataStorageReducer from './features/dataStorage';
import adobeTargetReducer from './features/adobeTarget';
import heycarpromotionReducer from './features/heycarpromotion';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; //eslint-disable-line

const store = createStore(
  combineReducers({
    form: formReducer,
    tlsSupport: tlsSupportReducer,
    iban: ibanReducer,
    price: priceReducer,
    transaction: transactionReducer,
    dealer: dealerReducer,
    asos: asosReducer,
    session: sessionReducer,
    dataStorage: dataStorageReducer,
    adobeTarget: adobeTargetReducer,
    heycarpromotion: heycarpromotionReducer
  }),
  composeEnhancer(applyMiddleware(thunk))
);

export { store };
